function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useState } from 'react';
import { Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import Modal from '@rd-web-markets/shared/dist/util/Modal';
import { handleError } from '@rd-web-markets/shared/dist/store/features/alertSlice';
import notesAndAssumptionsService from './notesAndAssumptions/notesAndAssumptions.service';
const CreateNoteModal = _ref => {
  let {
    show,
    onHide,
    claimId,
    category
  } = _ref;
  const {
    t
  } = useTranslation();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    comments: '',
    expenditure_category: category || ''
  });
  const {
    createNote
  } = notesAndAssumptionsService.useCrud(setLoading, claimId);
  const handleChange = e => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => _objectSpread(_objectSpread({}, prev), {}, {
      [name]: value
    }));
  };
  const handleSubmit = async () => {
    if (!formData.comments.trim()) {
      dispatch(handleError({
        message: t('comments_required')
      }));
      return;
    }
    await createNote(formData);
    setFormData({
      comments: '',
      expenditure_category: category || ''
    });
    onHide();
  };
  const getCategoryLabel = cat => {
    return t(cat);
  };
  const renderBody = () => {
    return /*#__PURE__*/React.createElement("div", {
      className: "p-3"
    }, /*#__PURE__*/React.createElement(Form.Group, {
      controlId: "category",
      className: "mb-3"
    }, /*#__PURE__*/React.createElement(Form.Label, null, t('category')), /*#__PURE__*/React.createElement(Form.Control, {
      type: "text",
      value: getCategoryLabel(formData.expenditure_category),
      disabled: true,
      readOnly: true
    })), /*#__PURE__*/React.createElement(Form.Group, {
      controlId: "comments",
      className: "mb-3"
    }, /*#__PURE__*/React.createElement(Form.Label, null, t('comments'), " *"), /*#__PURE__*/React.createElement(Form.Control, {
      as: "textarea",
      rows: 5,
      name: "comments",
      value: formData.comments,
      onChange: handleChange,
      placeholder: t('enter_comments'),
      disabled: loading
    })));
  };
  return /*#__PURE__*/React.createElement(Modal, {
    size: "lg",
    title: t('add_note'),
    show: show,
    renderBody: renderBody,
    onHide: onHide,
    onSubmit: handleSubmit,
    submitDisabled: loading || !formData.comments.trim(),
    submitText: loading ? t('saving') : t('create')
  });
};
export default CreateNoteModal;